// oxlint-disable-next-line no-restricted-imports
import { createRoutePath } from "@myvp/shared/src/functions/create-route-path"

const root = "/study"

const studyRouteNames = {
  root: createRoutePath(root),
  resources: createRoutePath(`${root}/resources`),
  consentForms: createRoutePath(`${root}/consent-forms`),
  details: createRoutePath(`${root}/details`),
}

export default studyRouteNames
